import { render, staticRenderFns } from "./tournamentInfo.vue?vue&type=template&id=160a5d99&"
import script from "./tournamentInfo.vue?vue&type=script&lang=js&"
export * from "./tournamentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports